import http from 'util/http'
import env from '@env'

const examBaseURL = env.exam
/** 获取上传token */
export function token() {
  return http.get('/upload/token', {})
}

export function qnToken(
  url = '/authorizations/qiniu/uploadToken',
  baseUrl = examBaseURL,
) {
  return http.get(
    url,
    { type: 1 },
    {
      baseUrl,
      structure: 'primitive',
    },
  )
}
